import React from "react";
import {
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  LineChart,
  Line,
} from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const SSNLineChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ left: -30 }}>
        {/* <CartesianGrid /> */}
        <XAxis dataKey="dateRange" padding={{ left: 30, right: 30 }} />
        <YAxis padding={{ top: 30, bottom: 0 }} />
        <Tooltip />
        <Legend margin={{ top: 50 }} />
        <Line
          type="monotone"
          dataKey="views"
          stroke="#6079E4"
          activeDot={{ r: 8 }}
        />
        <Line
          type="monotone"
          dataKey="saves"
          stroke="#3BC97E"
          activeDot={{ r: 8 }}
        />
        <Line
          type="monotone"
          dataKey="refers"
          stroke="#7D7B96"
          activeDot={{ r: 8 }}
        />
        {/* <Bar dataKey="rejected_cases" fill="#C92159" name="Rejected cases" /> */}
        {/* <Bar dataKey="closed_cases" fill="#7D7B96" name="Closed cases" /> */}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SSNLineChart;
